<template>
  <v-card flat>
    <v-card outlined flat class="PaymentCalculator">
      <f-loader v-if="showLoader" />
      <component
        v-if="showParseCreditReportForm && !showLoader"
        :is="parseCreditReportMetaData.componentName"
        :ref="parseCreditReportMetaData.myRefName"
        :value="selectModel(parseCreditReportInput, undefined)"
        @input="
          (newValue) => updateModel(parseCreditReportInput, newValue, undefined)
        "
        v-bind="parseCreditReportMetaData.props"
      ></component>
      <div class="d-flex align-center">
        <v-card-title>Calculator</v-card-title>
        <v-spacer />
        <!-- <v-btn
          class="mx-4"
          color="primary"
          small
          outlined
          @click="handleUploadCRClick"
        >
          Upload CreditReport<v-icon small>mdi-upload</v-icon></v-btn
        > -->
      </div>
      <TMOSSimulatorEditable
        ref="tmosSimulator"
        :value="simulatorResultLocal"
        :simulatorInput="paymentPlanInfo"
      />
      <component
        v-if="
          !!parsedCreditorListFDataTableMetaData &&
          parseCreditReportOutput.clCreditorCreditReportInfo.clCreditorCreditReportList.length > 0
        "
        :ref="parsedCreditorListFDataTableMetaData.myRefName"
        :is="parsedCreditorListFDataTableMetaData.componentName"
        :value="parseCreditReportOutput.clCreditorCreditReportInfo.clCreditorCreditReportList"
        v-bind="parsedCreditorListFDataTableMetaData.props"
      ></component>

      <v-card-title>Register a client</v-card-title>

      <component
        :ref="registerMyCFFFormMetaData.myRefName"
        :is="registerMyCFFFormMetaData.componentName"
        :value="selectModel(registerClientFormData, undefined)"
        v-bind="registerMyCFFFormMetaData.props"
      ></component>
    </v-card>
  </v-card>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as ServerData from "@/../src-gen/server-data";
import * as Action from "@/../src-gen/action";
import TMOStimulator from "@/components/generic/tmoStimulator/TMOStimulator.vue";
import TMOSSimulatorEditable from "@/components/generic/tmoStimulator/TMOSSimulatorEditable.vue";


import ModelVue from "@/components/ModelVue";
import RegisterMyCFFFormMDP from "./RegisterMyCFFFormMDP";

import FParseCreditReportFFormMDP from "../creditor/FParseCreditReportFFormMDP";
import ErrorResponse from "@/error-response";

import ParsedCreditorListFDataTableMDP from "./ParsedCreditorListFDataTableMDP";


import FForm from "@/components/form/FForm.vue";
import FBtn from "@/components/FBtn.vue";
import FDataTable from "@/components/table/FDataTable.vue";
import FLoader from "@/components/FLoader.vue";
@Component({
  components: {
    TMOSSimulatorEditable,
    FForm,
    FBtn,
    FDataTable,
    FLoader,
  },
})
export default class CalculateAndRegisterClientFile extends ModelVue {
  @Prop()
  onCancelClick: () => void;
  paymentPlanInfo: Data.ClientFile.FiPaymentPlanInfo =
    new Data.ClientFile.FiPaymentPlanInfo();
  // registerClientFormData: Data.Client.RegisterAndAddClientFileForm =
  //   new Data.Client.RegisterAndAddClientFileForm();
  registerClientFormData: Data.Client.RegisterAndEnrollInput =
    new Data.Client.RegisterAndEnrollInput();
  @Store.Getter.ClientFile.ClientFileSummary.clientFileBasicInfo
  clientFileBasicInfo: Data.ClientFile.ClientFileBasicInfo;
  @Store.Getter.Login.LoginDetails.loggedInUser
  loggedInUser: Data.Login.LoginDetails;
  addNoteInput: Data.FiNote.AddNoteInput = new Data.FiNote.AddNoteInput();
  clientFileNumber: string;
  showParseCreditReportForm: boolean = false;
  parseCreditReportOutput: Data.Spine.ParseCreditReportOutput =
    new Data.Spine.ParseCreditReportOutput();
  addDetailsFromParsedCRInput: Data.Spine.AddDetailsFromParsedCreditReportInput =
    new Data.Spine.AddDetailsFromParsedCreditReportInput();
  parseCreditReportInput: any = new Data.Spine.ParseCreditReportInput();
  simulatorResultLocal: any = {
    tenure: 0,
    settlementPercentage: 0,
    outstanding: 0,
    repaymentAmount: 0,
    monthlyPayment: 0,
    affordability: 0,
    msfAmount: 0,
    monthlyObligation: 0,
    firstSPADraftDate: "",
    tenureApproval: 0,
  };
  showLoader: boolean = false;

  getCFBasicInfoAndAddNote() {
    Action.ClientFile.GetClientFileBasicInfo.execute1(
      this.clientFileNumber,
      (output) => {
        setTimeout(() => {
          this.addNote();
        }, 1000);
      },
      error => {
        this.showLoader = false;
      }
    );
  }

  getSimulatorResult() {
    return (this.$refs["tmosSimulator"] as any)?.result;
  }

  setSimulatorResult() {
    (this.$refs["tmosSimulator"] as any).result.outstanding =
      this.parseCreditReportOutput.clCreditorCreditReportInfo.totalDebt;
  }

  addNote() {
    const result = this.getSimulatorResult();
    this.addNoteInput.clientFileId = this.clientFileBasicInfo.clientFileId;
    this.addNoteInput.noteMessage = `Outstanding Amount: ${result.outstanding}, \n Tenure: ${result.tenure} \n 
    Settlement Percentage: ${result.settlementPercentage},\n Monthly Payment: ${result.monthlyPayment},
    \n Affordability: ${result.affordability},
    \n MSF Amount: ${result.msfAmount}
    `;
    if (this.addNoteInput.noteMessage.length > 1) {
      Action.FiNote.AddNote.execute(this.addNoteInput, (output) => {
        this.showLoader = false;
        this.$router.replace({
          name: "PartnerAffiliate.CFile.CFTask.CFActiveTasks",
          params: { clientFileId: this.clientFileBasicInfo.clientFileId },
        });
      },
      error => {
        this.showLoader = false;
        ErrorResponse.handle(error);
      });
    }
  }
  handleRegisterFormCancelClick() {
    this.onCancelClick();
  }
  handleUploadCRClick() {
    this.showParseCreditReportForm = true;
  }
  closeAndClearAllForms() {
    this.showParseCreditReportForm = false;
  }

  addCreditorFromPDF() {
    this.showLoader = true;
    this.handleUploadCreditReportPDF();
  }


  handleUploadCreditReportPDF() {
    this.showLoader = true;
    // const parseCreditReportInput:Data.Spine.ParseCreditReportInput = Data.Spine.ParseCreditReportInput.fromJson(this.parseCreditReportInput.toJson());
    this.parseCreditReportInput.filename = this.getFileName(this.parseCreditReportInput.filename);
    // Action.Spine.ParseCreditReport.execute(
    //   this.parseCreditReportInput,
    //   (output) => {
    //     this.closeAndClearAllForms();
    //     this.parseCreditReportOutput = output;
    //     this.setSimulatorResult();
    //     this.registerClientFormData.firstName =
    //       this.parseCreditReportOutput.personalInfo.firstName;
    //     this.registerClientFormData.lastName =
    //       this.parseCreditReportOutput.personalInfo.lastName;
    //     this.showLoader = false;
    //   },
    //   (error) => {
    //     ErrorResponse.handle(error);
    //     this.showLoader = false;
    //   }
    // );
  }

  registerClient() {
    this.showLoader = true;
    Action.Spine.GetUserOrgCode.execute1(this.loggedInUser.userName, output => {
    this.registerClientFormData.orgCode = output.orgCode;
    Action.Client.RegisterAndEnroll.execute(
      this.registerClientFormData,
      (output) => {
        setTimeout(() => {
          this.clientFileNumber = output.clientFileNumber;
          this.getCFBasicInfoAndAddNote();
          // const parsePDF = new ParseCRPDF({
          //   clientFileNumber: output.clientFileNumber,
          //   parseCreditReportInput: this.parseCreditReportInput,
          //   parseCreditReportOutput: this.parseCreditReportOutput,
          // });
          // parsePDF.addDetailsFromParsedCR();
        }, 500);
      },
      error => {
        ErrorResponse.handle(error);
        this.showLoader = false;
      }
    );
  })
  }

  get parsedCreditorListFDataTableMetaData() {
    return new ParsedCreditorListFDataTableMDP({ parent: this }).getMetaData();
  }

  get parseCreditReportMetaData() {
    return new FParseCreditReportFFormMDP({ parent: this }).getMetaData();
  }

  get registerMyCFFFormMetaData() {
    return new RegisterMyCFFFormMDP({
      root: this,
      hideCancel: !this.onCancelClick,
    }).getMetaData();
  }

  getFileName(filePath: string = '') {
    return filePath?.split("/").pop()||'';
  }
}
</script>

<style>
</style>
